import React from 'react'
import { Link, NavLink } from "react-router-dom";

function Work() {
    return (
        <section className='work'>
            <div className="container">
                <div className="work-para d-flex align-items-center justify-content-center flex-column text-center"> {/*  data-aos="zoom-in" data-aos-easing="ease" data-aos-duration="1300" */}
                    <h5>How We Work</h5>
                    <h3>Our Process For Delivering Result</h3>
                    <p>We take a unique approach to bring your vision to life, delivering exceptional results every step of the way.</p>
                </div>
                <div className="work-hr d-flex align-items-center justify-content-center gap-3">
                    <hr />
                    <h6>Project in Steps</h6>
                </div>
                <div className="work-line d-flex justify-content-center gap-4 flex-wrap position-relative">
                    <div> {/*  data-aos="zoom-in" data-aos-easing="ease" data-aos-duration="1300" */}
                        <h2>01.</h2>
                        <h4>Make an Appointment</h4>
                    </div>
                    <div> {/* data-aos="zoom-in" data-aos-easing="ease" data-aos-duration="1500" */}
                        <h2>02.</h2>
                        <h4>Meet Our Team</h4>
                    </div>
                    <div> {/* data-aos="zoom-in" data-aos-easing="ease" data-aos-duration="1400" */}
                        <h2>03.</h2>
                        <h4>Get Consultation</h4>
                    </div>
                    <div> {/* data-aos="zoom-in" data-aos-easing="ease" data-aos-duration="1600" */}
                        <h2>04.</h2>
                        <h4>Start Project</h4>
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-center">
                    <Link to = "/Contact" className="btn_2 " style={{ border: '1px solid #FF7627' }} >Contact Now</Link>
                </div>
            </div>
        </section>
    )
}

export default Work
